import config from '../config';
import {
  customFetch,
  authHeader,
  jsonHeader,
  handleResponse,
  commonRequestOptions,
  subjects,
} from '../helpers';

const endpointPath = config.api.API_URL + '/connection';

export const connectionService = {
  getAll,
  getById,
  getBySystemId,
  getFormValues,
  getRelationshipImportQuery,
  validateDatasourceFilter,
  getDefaultImportQuery,
  getDefaultRelationshipQuery,
  getDefaultLineageQuery,
  testConnection,
  create,
  update,
  checkDestroy,
  destroy,
};

const _compileMultipartRequest = (data, files = []) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    formData.append(key, JSON.stringify(value));
  });

  files.forEach(file => {
    const fileProperties = Object.entries(file);
    if (fileProperties) {
      const key = fileProperties[0][0];
      const value = fileProperties[0][1];

      formData.append(key, value);
    }
  });
  return formData;
};

function getAll(signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/all`, requestOptions, signal).then(handleResponse);
}
function getById(id, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/${id}`, requestOptions, signal)
    .then(handleResponse)
    .then(res => {
      subjects.currentConnection.next(res.connections[0] || { connection_id: id });
      return res;
    });
}

function getBySystemId(id, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/system/${id}`, requestOptions, signal).then(handleResponse);
}

function getFormValues(signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/form_values`, requestOptions, signal).then(handleResponse);
}

function getRelationshipImportQuery(id, relationship_map, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(relationship_map),
  };
  return customFetch(
    `${endpointPath}/get_relationship_import_query/${id}`,
    requestOptions,
    signal
  ).then(handleResponse);
}

function validateDatasourceFilter(item, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(item),
  };
  return customFetch(`${endpointPath}/validate_datasource_filter`, requestOptions, signal).then(
    handleResponse
  );
}

function getDefaultImportQuery(item, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(item),
  };
  return customFetch(`${endpointPath}/get_default_import_query`, requestOptions, signal).then(
    handleResponse
  );
}

function getDefaultRelationshipQuery(item, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(item),
  };
  return customFetch(`${endpointPath}/get_default_relationship_query`, requestOptions, signal).then(
    handleResponse
  );
}

function getDefaultLineageQuery(item, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(item),
  };
  return customFetch(`${endpointPath}/get_default_lineage_query`, requestOptions, signal).then(
    handleResponse
  );
}

function testConnection(item, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(item),
  };

  return customFetch(`${endpointPath}/test_connection`, requestOptions, signal).then(
    handleResponse
  );
}

function create(items, files, signal) {
  try {
    const formData = _compileMultipartRequest(items, files);

    const requestOptions = {
      method: 'POST',
      headers: {
        ...authHeader(),
      },
      ...commonRequestOptions(),
      body: formData,
    };

    return customFetch(`${endpointPath}`, requestOptions, signal).then(handleResponse);
  } catch (e) {
    return Promise.reject(e);
  }
}

function update(items, files, signal) {
  try {
    const formData = _compileMultipartRequest(items, files);

    const requestOptions = {
      method: 'PUT',
      headers: {
        ...authHeader(),
      },
      ...commonRequestOptions(),
      body: formData,
    };

    return customFetch(`${endpointPath}`, requestOptions, signal).then(handleResponse);
  } catch (e) {
    return Promise.reject(e);
  }
}

function checkDestroy(items, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}/check_delete`, requestOptions, signal).then(handleResponse);
}

function destroy(items, signal) {
  const requestOptions = {
    method: 'DELETE',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}`, requestOptions, signal).then(handleResponse);
}
